import React, { Component } from 'react';
import { Form, Select} from 'antd';
import { injectIntl} from 'react-intl';
import ReportDescription from './ReportDescription'
import PrintersSelectTable from './PrintersSelectTable'
import {getReportParam} from '../utils/EmailReportsHelper'
import {REPORT_URL} from '../utils/constants'

const layout = {
    labelCol: {
        offset: 0,
        span: 0,
    },
/*    
    wrapperCol: {       
        offset: 0,
        span: 6,
    },
*/    
  };

const levels = [1, 10, 20, 50];
const report_type_name = "Report.ChangeDeviceConsumables";
const printer_id_name = "printer_id";
const report_url = "/printer_supplies_";

class ChangeDeviceConsumablesStep2 extends Component {

    constructor(props) {
        super(props);

        this.printer_id = this.getPrinterId();
        this.savePrinterId(this.printer_id);

        this.levels = levels.map (item => {
            return {key: item, description: item + '%'};
        });

        var level = this.getLevelValue()
        this.props.callbacks.setStoreValue(report_type_name, REPORT_URL, report_url +  level.toString());

        this.initial_level = level.toString() + '%';
 
    }

    getLevelValue()
    {
        const default_level = 50;
        var level;

        var stored_url = this.props.callbacks.getStoreValue(report_type_name, REPORT_URL);
        if (stored_url !== undefined)
        {
            level = this.getLevelFromUrl(stored_url);
        }
        else if (this.props.report.url !== undefined)
        {
            
            level = this.getLevelFromUrl(this.props.report.url);
        }

        return level !== undefined ? level : default_level;
    }

    getLevelFromUrl(url)
    {
        if (url === undefined)
        {
            return undefined;
        }

        var level;
        var indexQuestion = url.indexOf('?');
        var indexLast = url.lastIndexOf('_');

        if (indexQuestion !== -1)
        {
            var url_only = url.substring(0, indexQuestion);
            indexLast = url_only.lastIndexOf('_');
        }

        if (indexLast === -1)
        {
            return undefined;
        }

        level = parseInt(url.substring(indexLast + 1));

        return level;
    }

    savePrinterId(printer_id)
    {
        this.props.callbacks.setStoreValue(report_type_name, printer_id_name, printer_id);
    }

    getPrinterId()
    {
        return getReportParam(this.props.callbacks.getStoreValue, report_type_name, printer_id_name, this.props.report.url);
    }

    onSelectChange(selectedRowKeys) {
        this.printer_id = selectedRowKeys[0];
        this.savePrinterId(this.printer_id);
    }


    onLevelChange(e, option) {
        this.props.callbacks.setStoreValue(report_type_name, REPORT_URL, report_url +  option.key.toString());
    }

    render() {
    
        return (
            <div style={{align:"left", textAlign: "left"}}>
                <br/>
                <Form {... layout}
                    name="basic"
                    initialValues={{
                        "level": this.initial_level
                    }}                   
                >
                <Form.Item 
                      label={this.props.intl.formatMessage({id: "Report.ChangeDeviceConsumables.MinLevel"})}
                      name="level" 
                >
                <Select  style={{ width: 120 }} onChange={(e, option) => {this.onLevelChange(e, option)}}>
                    {this.levels.map(item => 
                        <Select.Option key  = {item.key} value={item.description}>{item.description}</Select.Option>)
                    }
                </Select>
                </Form.Item>                
                <Form.Item>
                <PrintersSelectTable 
                    printer_id = {this.printer_id}
                    onSelectChange = {(selectedRowKeys) => this.onSelectChange(selectedRowKeys)}/>
                </Form.Item>
                </Form>
                <ReportDescription description="Report.ChangeDeviceConsumables.Description"/>
            </div>
        );
      }
}

export default (injectIntl(ChangeDeviceConsumablesStep2, {
    withRef: true,
  }));